import { createRoot } from 'react-dom/client'
import { CartWidget } from './CartWidget.jsx'

const selector = '[data-nova-cart-widget]'

function parsePayload(element) {
  try {
    return JSON.parse(element.dataset.payload || '{}')
  } catch {
    return {}
  }
}

function mountCartWidget(element) {
  if (element.__novaReactRoot) return

  element.__novaReactRoot = createRoot(element)
  element.__novaReactRoot.render(<CartWidget payload={parsePayload(element)} />)
}

function mountCartWidgets(root = document) {
  if (root.matches?.(selector)) {
    mountCartWidget(root)
  }

  root.querySelectorAll?.(selector).forEach(mountCartWidget)
}

mountCartWidgets()

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        mountCartWidgets(node)
      }
    })
  })
})

observer.observe(document.documentElement, {
  childList: true,
  subtree: true,
})
